import {Dog} from './dog';

export class User {
    public id: string;
    public email: string;
    public password: string;
    public role: string;
    public name: string;
    public surname: string;
    public phone: string;
    public dni: string;
    public birthday: Date;
    public cp: string;
    public city: string;
    public address: string;
    public membershipNumber: string;
    public membershipActive: boolean;
    public firstContact: string;
    public emailing: boolean;
    public dogs: Dog[];
    public services: any[];
    public created: Date;
    public createdById: string;
    public createdBy: User;
    public updated: Date;
    public updatedById: string;
    public updatedBy: User;
    public gender: string;
    public godfatherType: string;
    public godfatherId: string;
    public agree: boolean;
    public agreeDate: Date;
    public gfType: string;
    public godfather: any;
}



// WEBPACK FOOTER //
// ./src/classes/user.ts